// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function localDraftMlsStatus_decode($$enum) {
  if ($$enum === "OnMls" || $$enum === "NotOnMls" || $$enum === "Error" || $$enum === "Called" || $$enum === "NotCalled" || $$enum === "OnMlsButAllowed") {
    return $$enum;
  }
  
}

function localDraftMlsStatus_fromString(str) {
  return localDraftMlsStatus_decode(str);
}

var Utils = {
  localDraftMlsStatus_decode: localDraftMlsStatus_decode,
  localDraftMlsStatus_fromString: localDraftMlsStatus_fromString
};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyWizardFormRelayValidatorsMLSTimingMLSListingType_formState",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mlsStatus",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "LocalDraftFormState",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
